<fgb-page-header [pageTitle]="'payment.page.title'" [backButtonLink]="'/'"></fgb-page-header>

<div class="container">
  <div class="mx-lg-auto">
    <div class="card-heading d-flex flex-row align-items-center justify-content-center">
      <span class="icon material-icons text-success" aria-hidden="true">add_card</span>
      <h6 class="text-success m-0 fw-bold text-uppercase font-size-14 card-title">
        {{ 'ecash.success.page.title' | translate }}
      </h6>
    </div>
    <div class="card-body">
      <div class="sub-heading-modal text-white font-size-14 text-center">
        {{ 'ecash.success.page.card.added' | translate }}
      </div>

      <button [routerLink]="['/payment']" type="button" class="btn fw-bold bg-white font-size-14">
        {{ 'ecash.success.page.close.button' | translate }}
      </button>
    </div>
  </div>
</div>
